import CertificationsPage from './CertificationsPage';

export default CertificationsPage;
